import request from './request';

export function createSession(data) {
  return request('post', `/apiv2/livestreams/sessions`, data);
}

export function startBroadcast(data) {
  return request('post', `/apiv2/livestreams/sessions/${data.id}/broadcast/start`, data);
}

export function createLivestream(data) {
  return request('post', `/apiv2/livestreams`, data);
}

export function updateLivestreamStatus(sessionId, data) {
  return request('patch', `/apiv2/livestreams/${sessionId}`, data);
}

export function generateToken(id, data) {
  return request('post', `/apiv2/livestreams/${id}/generate-token`, data);
}

export function updateEventLivestream(id, data) {
  return request('patch', `/apiv2/events/${id}/livestream`, data);
}

export async function fetchLivestreams(params) {
  return await request('get', `/apiv2/livestreams`, params);
}

export async function fetchVideos(params) {
  return await request('get', `/apiv2/crowdpac-tv`, params);
}
